import { DotPressGlobal } from '../models/wp';

export function getGlobal(): DotPressGlobal {
	// @ts-ignore
	return window?.dotPress || {};
}
